<template>
  <VanDialog
    :show="show_"
    :before-close="close"
    theme="round-button"
    title="给我密码"
  >
    <Field
      v-model="passValue"
      placeholder="管理员密码"
      input-align="center"
      type="password"
    />
  </VanDialog>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch } from "vue";
import { Dialog, Field } from "vant";
const VanDialog = Dialog.Component;
const props = defineProps({
  show: Boolean,
});
const passValue = ref("");
const show_ = ref(props.show);
watch(
  () => props.show,
  (value) => {
    show_.value = value;
  }
);
const emit = defineEmits(["update:show"]);
// 关闭弹窗
const close = () => {
  // 写入会话
  sessionStorage.setItem("AuthorizationCode", passValue.value);
  emit("update:show", !show_.value);
};
</script>
